"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const FormValidatorTypes_1 = require("../Enum/FormValidatorTypes");
const ValidationError_1 = require("auto-widget-framework/src/Error/ValidationError");
const FieldValidationError_1 = require("auto-widget-framework/src/Error/FieldValidationError");
class MixedFormValidator {
    constructor(formElement, questionnaire, validationConfig, factory) {
        this.baseFormValidator = factory
            .create(FormValidatorTypes_1.FormValidatorTypes.BASE, {
            form: formElement,
            config: validationConfig
        });
        this.questionnaireFormValidator = factory.create(FormValidatorTypes_1.FormValidatorTypes.QUESTIONNAIRE, {
            form: formElement,
            questionnaire: questionnaire
        });
    }
    /**
     * @inheritDoc
     */
    static create(formElement, questionnaire, validationConfig, container) {
        return new this(formElement, questionnaire, validationConfig, container.get('factory.form_validator'));
    }
    validate(values) {
        let promises = [];
        promises.push(this.baseFormValidator.validate());
        promises.push(this.questionnaireFormValidator.validate(values));
        return Promise.all(promises).then((results) => {
            // Both errors contain something
            if (results[0] !== null && results[1] !== null) {
                let firstError = results[1];
                let secondError = results[0];
                let errors = Object.assign(Object.assign({}, firstError.getValidationErrors()), secondError.getValidationErrors());
                let combinedError = new ValidationError_1.default(firstError.message + secondError.message, errors, firstError.getReferenceObject());
                return Promise.resolve(combinedError);
            }
            else {
                // This will result in either the non-null error or null if both are null
                let error = results[0] || results[1];
                return Promise.resolve(error);
            }
        });
    }
    validateField(inputName, value) {
        let promises = [];
        promises.push(this.baseFormValidator.validateField(inputName, value));
        promises.push(this.questionnaireFormValidator.validateField(inputName, value));
        return Promise.all(promises).then((results) => {
            // Both errors contain something
            if (results[0] !== null && results[1] !== null) {
                let firstError = results[1];
                let secondError = results[0];
                let combinedError = new FieldValidationError_1.default(firstError.message + secondError.message, firstError.getType(), firstError.getValueType(), firstError.getPropertyKey());
                return Promise.resolve(combinedError);
            }
            else {
                // This will result in either the non-null error or null if both are null
                let error = results[0] || results[1];
                return Promise.resolve(error);
            }
        });
    }
}
exports.default = MixedFormValidator;
Mixin_1.default(MixedFormValidator, IContainerInjection_1.default);
